import {
  ContentfulCloudinaryVideoMedia,
  ContentfulCloudinaryImage
} from '../../types/Contentful/ContentfulTypes'

export default class CloudinaryUtil {
  public static applyImageTransformation(imageUrl: string, transformationParam: string): string {
    let parsedUrl: URL

    try {
      parsedUrl = new URL(imageUrl)
    } catch {
      return imageUrl
    }

    const pathSegments = parsedUrl.pathname.split('/').filter(Boolean)

    const transformationIndex = pathSegments.findIndex((segment) =>
      CloudinaryUtil.isTransformationTokenSegment(segment)
    )

    if (transformationIndex === -1) {
      return imageUrl
    }

    const transformationSegment = pathSegments[transformationIndex]
    if (!transformationSegment) {
      return imageUrl
    }

    const existingTokens = transformationSegment
      .split(',')
      .map((token) => token.trim())
      .filter(Boolean)

    const desiredTokens = transformationParam
      .split(',')
      .map((token) => token.trim())
      .filter(Boolean)

    const desiredPrefixes = desiredTokens
      .map((token) => token.match(/^[a-z]+_/)?.[0])
      .filter((prefix): prefix is string => Boolean(prefix))

    const otherTokens = existingTokens.filter(
      (token) => !desiredPrefixes.some((prefix) => token.startsWith(prefix))
    )

    const finalTokens = [...desiredTokens, ...otherTokens]

    pathSegments[transformationIndex] = finalTokens.join(',')

    parsedUrl.pathname = `/${pathSegments.join('/')}`

    return parsedUrl.toString()
  }

  private static isTransformationTokenSegment(segment: string): boolean {
    const tokens = segment
      .split(',')
      .map((token) => token.trim())
      .filter(Boolean)

    if (!tokens.length) {
      return false
    }

    return tokens.some((token) => /^[a-z]{1,6}_/.test(token))
  }

  public static isVideo(
    media?: ContentfulCloudinaryImage | ContentfulCloudinaryVideoMedia
  ): boolean {
    return !!media && !!(media as ContentfulCloudinaryVideoMedia).video
  }

  public static getVideoUrl(
    media: ContentfulCloudinaryImage | ContentfulCloudinaryVideoMedia | undefined,
    screenClass: string
  ) {
    const videoMedia = media as ContentfulCloudinaryVideoMedia | undefined
    const url =
      screenClass === 'xs' ? videoMedia?.video?.mobileVideoUrl : videoMedia?.video?.videoUrl
    return url || videoMedia?.video?.videoUrl
  }

  public static getVideos(
    media: ContentfulCloudinaryImage | ContentfulCloudinaryVideoMedia | undefined
  ) {
    if (!media) return []

    const videoMedia = media as ContentfulCloudinaryVideoMedia
    const publicId = videoMedia?.video?.publicId
    if (!publicId) return []

    const baseUrl = 'https://cms.cloudinary.vpsvc.com/video/upload/'
    const breakpoints = [3840, 2560, 1920, 1080, 768, 480, 360]

    return breakpoints.map((bp) => {
      const transformation = `w_${bp},h_${bp / 2},c_limit,f_auto,q_auto`
      return {
        breakpoint: bp,
        src: `${baseUrl}${transformation}/${publicId}.mp4`,
        poster: `${baseUrl}so_0,${transformation}/${publicId}.jpg`
      }
    })
  }
}
